export default __webpack_public_path__ + "static/media/panbesy.fcd763e5.png";